import { render, staticRenderFns } from "./CardsAndTableDetailing.vue?vue&type=template&id=5e5843f9&scoped=true&"
import script from "./CardsAndTableDetailing.vue?vue&type=script&lang=js&"
export * from "./CardsAndTableDetailing.vue?vue&type=script&lang=js&"
import style0 from "./CardsAndTableDetailing.vue?vue&type=style&index=0&id=5e5843f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5843f9",
  null
  
)

export default component.exports